export const ProjectData=[
    {
        id:1,
        title:"Claretian Institute of philosophy",
        about: "A website for easy communication and management of admission process",
        tags:[".Net", "TypeScript", "VB", "Html/Css", ],
        demo:"http://www.cip.edu.ng",
        image:"https://github.com/krystopherNez/hostedImages/raw/main/projects/cip.png",
    },
    {
        id:2,
        title:"Divine Vision International School",
        about: "This is a .net school web application. It is designed for secondary schools and divine vision international was the first to use it, it handles everything from student application to accepting the student to checking results.",
        tags:[".Net", "TypeScript", "VB", "Html/Css", "Ajax"],
        demo:"http://divinevisioninternationalschool.com/",
        github:"https://github.com/krystopherNez",
        image:"https://github.com/krystopherNez/hostedImages/raw/main/projects/dvis.png",
    },
    {
        id:3,
        title:"OJU Electronics",
        about: "An ecommerce website for selling electronics and house hold gadgets. users can add product to cart, checkout, pay online, admin receives order and takes action",
        tags:[".Net", "TypeScript", "C#", "Html/Css", "Ajax"],
        demo:"https://ojuelectronics.com/",
        github:"https://github.com/krystopherNez",
        image:"https://github.com/krystopherNez/hostedImages/raw/main/projects/oju.png",
    },
    {
        id:4,
        title:"Online Kribs",
        about: "A property website designed to help relators connect with costomers display properties for sale or rent and get contact from the website when a user takes interest in any posted property",
        tags:[".Net", "TypeScript", "C#", "Html/Css", "Ajax"],
        demo:"http://onlinekribs.com/",
        github:"https://github.com/krystopherNez",
        image:"https://github.com/krystopherNez/hostedImages/raw/main/projects/okribs.png",
    },
    {
        id:5,
        title:"OMM Consult",
        about: "OMM Consult is an migration consultancy website that informs users of services offered by the company, how they can get started, cost and how to get in touch with the company",
        tags:[".Net", "TypeScript", "C#", "Html/Css", "Ajax"],
        demo:"http://ommconsult.com/",
        github:"https://github.com/krystopherNez",
        image:"https://github.com/krystopherNez/hostedImages/raw/main/projects/omm.png",
    },
    {
        id:6,
        title:"ABC Capital Limited",
        about: "ABC Capital Limited is an Financial consultancy website that informs users of services offered by the company, how they can get started, cost and how to get in touch with the company. Users can create an account, view their financial activities with the company, etc",
        tags:[".Net", "TypeScript", "C#", "Html/Css", "Ajax"],
        demo:"http://abccapitallimited.com/",
        github:"https://github.com/krystopherNez",
        image:"https://github.com/krystopherNez/hostedImages/raw/main/projects/abc.png",
    },
    {
        id:6,
        title:"AFJ Farms",
        about: "AFJ Farms is an ecommerce website for selling farm produce. Users can add product to cart, checkout and make payment online",
        tags:["Laravel", "TypeScript", "jQuery", "Html/Css", "Bootstrap"],
        demo:"http://afjfarms.com/",
        github:"https://github.com/krystopherNez",
        image:"https://github.com/krystopherNez/hostedImages/raw/main/projects/afj.png",
    },
    {
        id:7,
        title:"Comdoity",
        about: "Comdoity is a social newtorking application where users can exchange services in exchange of getting services rendered to them",
        tags:["Laravel", "TypeScript", "jQuery", "Html/Css", "Bootstrap"],
        demo:"http://comdoity.com/",
        github:"https://github.com/krystopherNez",
        image:"https://github.com/krystopherNez/hostedImages/raw/main/projects/comdoity.png",
    },
];